<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-card class="mt-5" outlined>
    <v-card-title>
      {{ $t('project.readiness') }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="project.drawerName"
            :disabled="saving"
            :label="$t('project.drawer_name')"
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="project.notice"
            :disabled="saving"
            :label="$t('project.notice')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.installation" :disabled="saving"
                      :label="$t('project.installation')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.installationDescription"
            :disabled="saving"
            :label="$t('project.installation_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.basicMeasurementGuide" :disabled="saving"
                      :label="$t('project.basic_measurement_guide')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
          <v-text-field v-model="project.basicMeasurementGuideDrawer" :disabled="saving"
                        :label="$t('project.basic_measurement_guide_drawer')"
                        autocomplete="off"
                        class="mt-2"
                        dense
                        hide-details
                        light
                        outlined
          >
            <template v-slot:prepend-inner>
              <v-icon>mdi mdi-draw</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.basicMeasurementGuideDescription"
            :disabled="saving"
            :label="$t('project.basic_measurement_guide_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox
            v-model="project.workPictures" :disabled="saving"
            :label="$t('project.work_pictures')"
            autocomplete="off"
            dense
            hide-details
            light
            outlined></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.workPicturesDescription"
            :disabled="saving"
            :label="$t('project.work_pictures_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox
            v-model="project.constructionDrawings" :disabled="saving"
            :label="$t('project.construction_drawings')"
            autocomplete="off"
            dense
            hide-details
            light
            outlined></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.constructionDrawingsDescription"
            :disabled="saving"
            :label="$t('project.construction_drawings_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.buildingPermission" :disabled="saving"
                      :label="$t('project.building_permission')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
          <v-text-field v-model="project.buildinPermissionDrawer" :disabled="saving"
                        :label="$t('project.building_permission_drawer')"
                        autocomplete="off"
                        class="mt-2"
                        dense
                        hide-details
                        light
                        outlined
          >
            <template v-slot:prepend-inner>
              <v-icon>mdi mdi-draw</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.buildingPermissionDescription"
            :disabled="saving"
            :label="$t('project.building_permission_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.bvn" :disabled="saving"
                      :label="$t('project.bvn')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
          <v-text-field v-model="project.bvnDrawer" :disabled="saving"
                        :label="$t('project.bvn_drawer')"
                        autocomplete="off"
                        class="mt-2"
                        dense
                        hide-details
                        light
                        outlined
          >
            <template v-slot:prepend-inner>
              <v-icon>mdi mdi-draw</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.bvnDescription"
            :disabled="saving"
            :label="$t('project.bvn_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.materialsList" :disabled="saving"
                      :label="$t('project.materials_list')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.materialsListDescription"
            :disabled="saving"
            :label="$t('project.materials_list_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-2"/>
      <v-row>
        <v-col cols="12" md="4">
          <v-checkbox v-model="project.windowsAndDoors" :disabled="saving"
                      :label="$t('project.windows_and_doors')"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <v-textarea
            v-model="project.windowsAndDoorsDescription"
            :disabled="saving"
            :label="$t('project.windows_and_doors_description')"
            auto-grow
            autocomplete="off"
            dense
            hide-details
            light
            outlined
          >
          </v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ProjectReadinessCard',
  props: {
    project: {
      type: Object,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    }
  }
}
</script>
